export default __webpack_public_path__ + "394d33b51186aaef1e1d42eadfba9cb9.png";